import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { classIf } from '../../data/utils/classIf';
import { formatDateWithWeekDay } from '../../data/utils/formatDateWithWeekDay';
import { getConfiguration } from '../../data/utils/configuration';
import { getSplitDesc } from '../../data/utils/getSplitDesc';
import { oddToString } from '../../data/utils/oddToString';
import { getLabel } from '../../data/labels';
import AmountBetslipForm from './AmountBetslipForm';
import { LiveScoresContext } from './LiveScoresProvider';
import EventScores from './EventScores';
import StakesPicker from './StakesPicker';

function getBetKey(couponKey, container, event, bet) {
    return `bet-draw-sel-${couponKey}-container-${container}-pal-${event.pal}-avv-${event.avv}-scom-${bet.scomSogei}_${bet.handicap}-draw-${bet.draw}`;
}

function getServiceIcons(score) {
    let team1Icon = null;
    let team2Icon = null;
    
    try {
        if (score.sourceServing !== '') {
            if (score.srv === 1) {
                team1Icon = score.sourceServing;
            } else {
                team2Icon = score.sourceServing;
            }
        }
    } catch (e) {}

    return [team1Icon, team2Icon];
}

function CouponEvent(props) {
    const conf = getConfiguration();
	const bankerEnabled = conf.sybe != null? conf.sybe : true;
    const betslipContext = useContext(BetslipContext);
    const liveScores = useContext(LiveScoresContext);
	const betslipData = betslipContext.getBetslipData();

    function deleteSelection(scomSogei, handicap, codDraw, removeAllBets) {
    	if (removeAllBets) {
    		scomSogei = null;
    		codDraw = null;
    		handicap = null;
    	}
    	betslipContext.toggleSelectionBetslip(event.pal, event.avv, null, null, null, scomSogei, handicap, null, codDraw, null, null);
    }

    function deleteBet() {
        if (tabSingle || (tabMulti && event.bets[0].legabile)) {
            const bet = event.bets[0];
            deleteSelection(bet.scomSogei, bet.handicap, bet.draw, false);	
        } else {
            deleteSelection(null, null, null, true);		
        }
    }
    
    function toggleBanker() {
    	if (bankerEnabled) {
    		event.banker = !event.banker;
    		betslipContext.setBetslipData(betslipData, true);    		
    	}
    }
	
	const couponKey = props.couponKey;
    let alias = props.selection.alias;
    alias = alias == null ? '' : alias + ' ';
    const container = props.container;
    let tabSingle = container === 'singlebets';
    let tabMulti = container === 'multibets';
    
    let event = props.selection;
    
    let descSportTournament = null;
    if (props.selection.descSport?.length > 0) {
    	descSportTournament = props.selection.descSport;
    }
    
    if (props.selection.descTournament?.length > 0) {
    	if (descSportTournament == null) {
    		descSportTournament = props.selection.descTournament;
    	} else {
    		descSportTournament = `${descSportTournament} - ${props.selection.descTournament}`;
    	}
    }
    
    const parts = event.descEvent.split(" - ");
    let homeTeam = parts[0];
    let awayTeam = parts[1];
    
    let bets = event.bets;
    // restoring the bets array: if it is not a systembet, then I will draw just the first bet
    if (container !== 'systembets' && !betslipContext.isBetBuilder()) {
    	let aux = [];    
    	if (bets.length > 0) {
    		aux.push(bets[0]);
    	}
    	bets = aux;
    }
   
    let blinkElement = false;
    if (event.closed == null || event.closed == false) {
    	for (let km in event.bets) {
    		blinkElement = blinkElement || (event.bets[km].updated != null || event.bets[km].closed); 
    	}
    } else {
    	blinkElement = true;
    }

    blinkElement = false; // TODO: check if we need another effect

    const [date, time] = getSplitDesc(formatDateWithWeekDay(event.timestamp).dayMonthTime);
    const eventId = `${event.pal}_${event.avv}`;
    const score = liveScores?.has(eventId) ? liveScores.get(eventId) : null;
    const eventScores = score?.formattedScores;

    return (
        <>
            <div className={"cartEvent" + (blinkElement? ' blink': '')}>
                {event.closed &&
                    <div>{getLabel('betslip_alt.event.event_closed')}</div>
                }
                <div className="cartEvent__header">
                    {descSportTournament &&
                        <div className="cartEvent__title">{descSportTournament}</div>
                    }
                    <div className="cartEvent__header__controls">
                        <div className="cartEvent__header__control cartEvent__header__control--delete" onClick={deleteBet}></div>
                    </div>
                </div>
                <div className="cartEvent__body">
                    <div className="cartEvent__body__title">
                        <div className="cartEvent__body__date">
                            {event.isLive ?
                                <div className="cart__liveBadge">LIVE</div>
                                :
                                <span>{date}</span>
                            }
                        </div>
                        {alias != null &&
                            <div className="cartEvent__body__alias">{alias}</div>
                        }
                    </div>
                    <div className="cartEvent__body__inner">
                        {event.isLive ?
                            <div className="cartEvent__time cartEvent__time--live">
                                {score &&
                                    <span>{score.periodo} {score.currentMinute}</span>
                                }
                            </div>
                            :
                            <div className="cartEvent__time">{time}</div>
                        }
                        <table className="cartEvent__table">
                            <tbody>
                                {eventScores &&
                                    <tr>
                                        <td className="cartEvent__team__td">
                                            <div className="cartEvent__team"></div>
                                        </td>
                                        <>
                                            {eventScores.map((s, i) =>
                                                <td key={i} className={"cartEvent__score__td" + classIf(i === 0, 'cartEvent__score__td--live')}>
                                                    <div className="cartEvent__score">{s.p}</div>
                                                </td>
                                            )}
                                        </>
                                    </tr>
                                }
                                <tr>
                                    <td className="cartEvent__team__td">
                                        <div className="cartEvent__team">
                                            {homeTeam}
                                            {score?.srv === 1 &&
                                                <span className="liveServiceDot" />
                                            }
                                        </div>
                                    </td>
                                    {score &&
                                        <EventScores scores={eventScores} type={1} />
                                    }
                                </tr>
                                {awayTeam != null &&
                                    <tr>
                                        <td className="cartEvent__team__td">
                                            <div className="cartEvent__team">
                                                {awayTeam}
                                                {score?.srv === 2 &&
                                                    <span className="liveServiceDot" />
                                                }
                                            </div>
                                        </td>
                                        {score &&
                                            <EventScores scores={eventScores} type={2} />
                                        }
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {bets.map(bet => {
                    let reactKey = getBetKey(couponKey, container, event, bet);
                    return (
                        <React.Fragment key={reactKey}>
                            {tabSingle && conf.bak?.mob === true &&
                                <div className="cartEvent__footer">
                                    <div className="cartEvent__footer__inputsContainer">
                                        <StakesPicker couponKey={couponKey} 
                                                        isEventForm={true} 
                                                        pal={event.pal} 
                                                        avv={event.avv}
                                                        scomSogei={event.bets[0].scomSogei}
                                                        handicap={event.bets[0].handicap}
                                                        draw={event.bets[0].draw}/>
                                    </div>
                                </div>
                            }
                            <div className="cartEvent__footer">
                                {container === 'systembets' && bankerEnabled &&
                                    <div className={"cartEvent__fixButton" + classIf(event.banker, 'cartEvent__fixButton--active')} onClick={toggleBanker}>FIX</div>
                                }
                                <div className={"cartEvent__betDescription" + (bet.closed? ' opacityEventClosed' : '')}>
                                    <span>{bet.descBet}</span>
                                    <span className="cartEvent__betDescription__value">{bet.descDraw}</span>
                                </div>
                                <div className="cartEvent__betQuote">
                                    {bet.closed ? getLabel('general.giocabilita_chiusa') : (betslipContext.isBetBuilder()? '' : oddToString(bet.odd))}
                                </div>
                                <div className="cart__footer__betInputRow">
                                    {tabSingle &&
                                        <AmountBetslipForm container={container} 
                                                            couponKey={couponKey} 
                                                            isEventForm={true} 
                                                            pal={event.pal} 
                                                            avv={event.avv}
                                                            scomSogei={event.bets[0].scomSogei}
                                                            handicap={event.bets[0].handicap}
                                                            draw={event.bets[0].draw} />
                                    }
                                </div>
                            </div>
                        </React.Fragment>
                    )
                })}
            </div>
        </>
    );
}

export default CouponEvent;
